{
  "file": {
    "byte": "octet",
    "bytes": "octets",
    "kB": "ko",
    "MB": "Mo",
    "GB": "Go",
    "TB": "To"
  }
}
